module.exports = __webpack_public_path__ + "static/we-give-a-truck-logo-75d6142069c3ebbc2b439e01dcf5f0e5.svg";